import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
const StyledTag = ({ color, content }) => <Tag color={color}>{content}</Tag>;

StyledTag.propTypes = {
  color: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};

export default StyledTag;
